<template>
  <v-container fluid>
    <v-row align="center" justify="center" style="height:90vh">
      <v-card width="400" class="mx-5">
        <v-card-title class="headline white--text primary gradient-mariana py-3" primary-title>
          <!-- <v-icon color="black" left class="white--text mr-3">mdi-information-outline</v-icon> -->
          <span style="margin-bottom:-5px">💌 Contact</span>
        </v-card-title>
        <v-form ref="form" v-model="valid" lazy-validation class="pa-5">
          <v-card-text class="mx-0 px-0">
            We are still working on this app. Keen to be our beta users and help
            us shape the future of AYA's app? Leave your email & join the tribe
            🙋
          </v-card-text>

          <v-text-field
            v-model.trim="email"
            :rules="emailRules"
            autocomplete="email"
            placeholder="E-mail"
            required
            outlined
            class="mt-3"
          ></v-text-field>
          <div
            v-if="!addMessage"
            @click="addMessage = !addMessage"
            style="text-decoration:underline;text-align:center;opacity:0.5;margin-top:-10px;margin-bottom:20px;cursor:pointer"
          >Add a message</div>
          <v-textarea
            v-if="addMessage"
            rows="3"
            placeholder="Your message (optional)"
            counter
            :rules="textRules"
            v-model="text"
            auto-grow
            outlined
          ></v-textarea>

          <v-row justify="center">
            <v-btn
              :disabled="!valid || loading"
              :loading="loading"
              color="primary"
              class="px-5 text-none"
              @click="validate"
              rounded
              depressed
            >
              Send
              <span v-if="!user.emailSent" class="ml-1">(+3⭐)</span>
              <v-icon right small>mdi-send</v-icon>
            </v-btn>
          </v-row>
        </v-form>
        <!-- <v-card-text class="mb-0 pb-2"></v-card-text> -->
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";

export default {
  metaInfo() {
    return {
      meta: [
        {
          name: "theme-color",
          content: this.color
        }
      ]
    };
  },
  data: () => ({
    addMessage: false,
    loading: false,
    valid: true,
    email: "",
    emailRules: [
      v => !!v || "E-mail is required",
      v =>
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          v
        ) || "E-mail must be valid"
    ],
    textRules: [v => v.length <= 500 || "Max 500 characters"],
    text: ""
  }),
  methods: {
    validate() {
      this.loading = true;
      if (this.$refs.form.validate()) {
        this.$store.commit("setSnackbar", {
          color: "primary",
          timeout: 4000,
          text: "Thank you 🎈"
        });
        if (!this.user.emailSent) {
          this.$store.commit("setReward", {
            overlay: true,
            src: "",
            value: 3,
            name: "Email"
          });
          this.$store.dispatch("updateUserCredits", 3);
        }

        this.$store.dispatch("sendEmail", {
          email: this.email,
          text: this.text
        });

        this.loading = false;
        this.dialogContact = false;
        this.email = "";
        this.text = "";
        this.$router.push("/");
      }
      this.loading = false;
    }
  },
  computed: {
    ...mapState(["user", "lightMode"]),
    color() {
      if (this.lightMode) {
        return "#62A0F0";
      } else {
        return "#021F23";
      }
    },
    dialogContact: {
      get() {
        return this.$store.state.dialogContact;
      },
      set(val) {
        return this.$store.commit("setDialogContact", val);
      }
    }
  }
};
</script>

<style>
/* .v-card,
.v-dialog {
  border-radius: 20px !important;
}
.button-shadow {
  box-shadow: 0px 3px 15px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 50px #d4f8e8,
    0px 3px 15px 50px rgba(0, 0, 0, 0.2), 0px 0px 0px 200px #f67575,
    0px 3px 15px 200px rgba(0, 0, 0, 0.2), 0px 0px 0px 600px #ffa34d,
    0px 3px 15px 600px rgba(0, 0, 0, 0.2) !important;
} */

/* * {
  border: solid 1px red;
} */

/* @keyframes zoominout {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.9);
  }
  100% {
    transform: scale(1);
  }
} */

/* .number-of-cups {
  display: inline-block;
  animation: zoominout 1s infinite;
} */
</style>
